(() => {
  const root = document.getElementById('shop-eggraw');

  /* Litres calculator inside the buy box */
  const calc = document.querySelector('[data-b2b-calc]');
  if (calc && root) {
    const whites = calc.querySelector('[data-b2b-whites]');
    const days = calc.querySelector('[data-b2b-days]');
    const pick = calc.querySelector('[data-b2b-pick]');
    const tiers = () => [...root.querySelectorAll('input[data-er-variant]')]
      .filter((i) => !i.disabled)
      .map((i) => ({ input: i, litres: Number(i.dataset.litres) }))
      .sort((a, b) => a.litres - b.litres);
    let target = null;
    const render = () => {
      const perDay = Math.min(3000, Math.max(10, Math.round(Number(whites.value) || 10)));
      const litres = (perDay * 30 * Number(days.value)) / 1000;
      calc.querySelector('[data-b2b-litres]').textContent = Number(litres.toFixed(1)) + ' L';
      calc.querySelector('[data-b2b-bottles]').textContent = Math.ceil(litres * 2);
      calc.querySelector('[data-b2b-protein]').textContent = Math.round(perDay * 3) + ' g';
      const list = tiers();
      const largest = list[list.length - 1];
      target = list.find((t) => t.litres >= litres) || null;
      if (!target && largest && litres > largest.litres) {
        pick.textContent = 'Over ' + largest.litres + ' L a week? Get a bulk quote →';
        pick.dataset.mode = 'quote';
      } else if (target) {
        pick.textContent = 'Choose the ' + target.litres + ' L plan →';
        pick.dataset.mode = 'tier';
      }
    };
    calc.querySelectorAll('[data-b2b-step]').forEach((b) => b.addEventListener('click', () => {
      whites.value = Math.max(10, (Number(whites.value) || 0) + Number(b.dataset.b2bStep));
      render();
    }));
    whites.addEventListener('input', render);
    days.addEventListener('change', render);
    pick.addEventListener('click', () => {
      if (pick.dataset.mode === 'quote') { document.getElementById('enquiry')?.scrollIntoView({ behavior: 'smooth' }); return; }
      if (target && !target.input.checked) target.input.click();
      calc.open = false;
      root.querySelector('.b2b-tiers')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    render();
  }

  /* Weekly supply stays the default choice after a litres change, unless the buyer picked one-time. */
  if (root) {
    let choseOnce = false;
    root.addEventListener('click', (e) => {
      if (e.target.closest('.easymsgonetimelabel, .er-native-choice')) choseOnce = true;
      if (e.target.closest('.easymsgsubsplanlabel, .easymsggroupcontainer')) choseOnce = false;
    });
    const keepWeekly = () => {
      if (choseOnce) return;
      const weekly = root.querySelector('.easymsgradiobig[data-selling-plan-id]');
      if (weekly && !weekly.checked) weekly.click();
    };
    root.querySelectorAll('input[data-er-variant]').forEach((i) => i.addEventListener('change', () => {
      setTimeout(keepWeekly, 250);
      setTimeout(keepWeekly, 900);
    }));
  }

  /* Weekly option: strip, struck one-time price and pointers (4-week bill and saving, before GST) */
  if (root) {
    const inr = (n) => '₹' + Math.round(n).toLocaleString('en-IN');
    let busy = false;
    const perks = () => {
      if (busy) return;
      const list = root.querySelector('.er-easy-subscribe-perks');
      const i = root.querySelector('input[data-er-variant]:checked');
      if (!list || !i) return;
      const L = Number(i.dataset.litres), w = Number(i.dataset.weekNet), o = Number(i.dataset.onceNet);
      /* Own strip and struck one-time price (the shared widget scripts rewrite their own copies, so these are separate nodes). */
      const pct = Math.round((1 - w / o) * 100);
      const label = root.querySelector('.easymsgsubsplanlabel');
      if (label) {
        const card = label.closest('.easymsggroupcontainer') || label;
        let strip = card.querySelector('.b2b-strip');
        if (!strip) { strip = document.createElement('span'); strip.className = 'b2b-strip'; card.prepend(strip); }
        const stripText = 'Most popular with kitchens · Save ' + pct + '%';
        if (strip.textContent !== stripText) strip.textContent = stripText;
        const main = label.querySelector('.er-subscription-price-main');
        if (main) {
          let was = main.querySelector('.b2b-was');
          if (!was) { was = document.createElement('s'); was.className = 'b2b-was'; main.prepend(was); }
          const once = i.dataset.priceFormatted || '';
          if (was.textContent !== once) { was.textContent = once; was.setAttribute('aria-label', 'One-time price ' + once); }
        }
      }
      const items = ['<b>' + inr(w * L * 4) + ' + GST</b> billed every 4 weeks', '<b>Save ' + inr((o - w) * L * 4) + '</b> every 4 weeks vs one-time'];
      const key = items.join('|');
      if (list.dataset.b2bKey === key && list.querySelector('.b2b-perk')) return;
      busy = true;
      list.querySelectorAll('.b2b-perk').forEach((n) => n.remove());
      [...list.children].forEach((li, k) => { if (k === 0 || k === 3) li.classList.add('b2b-hide'); });
      items.slice().reverse().forEach((h) => { const li = document.createElement('li'); li.className = 'b2b-perk'; li.innerHTML = h; list.prepend(li); });
      list.dataset.b2bKey = key;
      busy = false;
    };
    root.querySelectorAll('input[data-er-variant]').forEach((i) => i.addEventListener('change', () => { setTimeout(perks, 300); setTimeout(perks, 1000); }));
    const slot = root.querySelector('.er-subscription-slot');
    let t;
    if (slot) new MutationObserver(() => { clearTimeout(t); t = setTimeout(perks, 150); }).observe(slot, { childList: true, subtree: true });
    perks();
  }

  /* Product gallery */
  document.querySelectorAll('[data-b2b-gallery]').forEach((g) => {
    const slides = g.querySelectorAll('[data-b2b-slide]');
    const thumbs = g.querySelectorAll('[data-b2b-thumb]');
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const n = Number(t.dataset.b2bThumb);
      slides.forEach((s, k) => { s.hidden = k !== n; });
      thumbs.forEach((b, k) => b.setAttribute('aria-pressed', String(k === n)));
    }));
  });

  /* Arriving from the cart's weekly offer: remember this page and preselect the litres. */
  try { sessionStorage.setItem('eggrawB2bUrl', location.pathname + location.search.replace(/[?&]litres=\d+/, '')); } catch (e) { /* storage unavailable */ }
  const want = new URLSearchParams(location.search).get('litres');
  if (root && want) {
    const pickTier = () => {
      const input = root.querySelector('input[data-er-variant][data-litres="' + want + '"]');
      if (input && !input.checked) input.click();
    };
    setTimeout(pickTier, 600);
    setTimeout(pickTier, 1500);
  }

  /* Video: load YouTube only when played */
  document.querySelectorAll('[data-b2b-video]').forEach((btn) => btn.addEventListener('click', () => {
    const id = btn.dataset.b2bVideo;
    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
    frame.title = btn.getAttribute('aria-label') || 'EGG RAW video';
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    frame.allowFullscreen = true;
    btn.replaceWith(frame);
  }));

  /* Show the enquiry result after a submission. */
  if (document.querySelector('#b2b-contact-form .b2b-success, #b2b-contact-form .b2b-error')) {
    document.getElementById('enquiry')?.scrollIntoView({ block: 'start' });
  }

  /* Mobile bar: hide while the buy box or the enquiry form is on screen. */
  const bar = document.querySelector('[data-b2b-mobilebar]');
  const targets = ['shop-eggraw', 'enquiry'].map((id) => document.getElementById(id)).filter(Boolean);
  if (bar && targets.length && 'IntersectionObserver' in window) {
    const visible = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
      bar.toggleAttribute('data-hidden', visible.size > 0);
    }, { threshold: 0.15 });
    targets.forEach((t) => io.observe(t));
  }
})();
